export interface NetworkingError {
  errors: string[];
  status: number;
  // Full parsed response body — preserves structured fields the backend
  // returns alongside `errors` (e.g. `errorCode`, `senderType`).
  data?: Record<string, unknown>;
}

export function isNetworkingError(error: NetworkingError | any): error is NetworkingError {
  return error !== null && typeof error === "object" && typeof (error as NetworkingError).status === "number";
}
